//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SectionAgencyLegalInformationInn",
  props: {
    inn: {
      type: String,
      default: () => ""
    }
  }
};
